import * as Immutable from 'immutable';
import {
    STATE_INITIAL,
} from '../services/state/types';

export default Immutable.Map(Object.assign({}, {
    status: STATE_INITIAL,
}));